import { makeEnvironmentProviders } from '@angular/core';
import { provideTicketsDomain } from '@zero/tickets/domain';
import { provideCryptoOnboardingFeature, provideTaxFeature, provideTerminateDepotFeature } from './+state';
import { provideEmailChangeFeature } from './+state/email-change/provide';
import { provideSepaFeature } from './+state/sepa/provide';

export const provideSelfServiceDomain = () => {
  return makeEnvironmentProviders([
    provideCryptoOnboardingFeature(),
    provideTaxFeature(),
    provideTerminateDepotFeature(),
    provideTicketsDomain(),
    provideSepaFeature(),
    provideEmailChangeFeature(),
  ]);
};
